import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import siteMessage from "@insite/client-framework/SiteMessage";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import merge from "lodash/merge";
import React, { useState } from "react";
import { css } from "styled-components";

const enum fields {
    redirectUrl = "redirectUrl",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.redirectUrl]: LinkFieldValue;
    };
    extendedStyles?: CodeSnippetStyles;
}

type Props = OwnProps & HasShellContext;

export interface CodeSnippetStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    instructionText?: TypographyPresentationProps;
}

export const codeSnippetStyles: CodeSnippetStyles = {
    wrapper: {
        css: css`
            background: #e5e5e5;
            padding: 10px;
        `,
    },
    titleText: {
        variant: "h6",
        css: css`
            margin: 0;
        `,
    },
};

const RedirectWidget = ({ fields, shellContext, extendedStyles }: Props) => {
    const [styles] = useState(() => merge(codeSnippetStyles, extendedStyles));
    const link = useGetLink(fields.redirectUrl);

    React.useEffect(() => {
        if (!shellContext.isInShell && !shellContext.isEditing && link.url !== undefined && link.url !== "") {
            window.location.href = link.url as string;
        }
    }, []);

    return (
        <>
            {shellContext.isInShell && shellContext.isEditing && (
                <StyledWrapper {...styles.wrapper}>
                    <Typography {...styles.titleText}>{translate("Redirect Widget")}</Typography>
                    <Typography {...styles.instructionText}>{siteMessage("RedirectWidget_Instruction")}</Typography>
                </StyledWrapper>
            )}
            <div></div>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withIsInShell(RedirectWidget),
    definition: {
        group: "Basic",
        canAdd: context => context.permissions?.canUseAdvancedFeatures || false,
        fieldDefinitions: [
            {
                name: fields.redirectUrl,
                displayName: "Redirect Link",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
